import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin, Phone } from "lucide-react";
import { riverStone, footerNav, IMG } from "../data/brand";
import { NewsletterForm } from "./NewsletterForm";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0a0908] border-t border-white/10 pt-20 pb-10 grain relative">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="grid md:grid-cols-12 gap-12 pb-16">
        {/* Brand */}
        <div className="md:col-span-5">
          <img src={IMG.logo} alt="River Stone Chophouse" className="h-24 w-auto" />
          <p className="text-white/50 text-sm font-light leading-relaxed mt-6 max-w-sm">
            Coastal Virginia's premier chophouse. Premium steaks, fresh seafood and a spirited raw bar in the heart of Harbour View.
          </p>
          <div className="flex gap-4 mt-8">
            <a href={riverStone.social.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram"
              className="w-11 h-11 border border-white/20 flex items-center justify-center text-white/70 hover:border-[#C1272D] hover:text-[#C1272D] transition-colors">
              <Instagram size={18} />
            </a>
            <a href={riverStone.social.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook"
              className="w-11 h-11 border border-white/20 flex items-center justify-center text-white/70 hover:border-[#C1272D] hover:text-[#C1272D] transition-colors">
              <Facebook size={18} />
            </a>
          </div>
          <NewsletterForm />
        </div>

        {/* Nav */}
        <div className="md:col-span-3">
          <p className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-6">Explore</p>
          <ul className="space-y-3">
            {footerNav.map((item) => (
              <li key={item.label}>
                {item.href ? (
                  <a href={item.href} target="_blank" rel="noreferrer" className="text-white/70 hover:text-[#C1272D] text-sm font-light tracking-wide transition-colors">{item.label}</a>
                ) : (
                  <Link to={item.to} className="text-white/70 hover:text-[#C1272D] text-sm font-light tracking-wide transition-colors">{item.label}</Link>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="md:col-span-4">
          <p className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-6">Visit</p>
          <a href={riverStone.location.mapUrl} target="_blank" rel="noreferrer" className="flex gap-3 text-white/70 hover:text-[#C1272D] transition-colors mb-4">
            <MapPin size={18} className="mt-0.5 shrink-0 text-[#C1272D]" />
            <span className="text-sm font-light leading-relaxed">
              {riverStone.location.address}<br />{riverStone.location.cityStateZip}
            </span>
          </a>
          <a href={riverStone.phoneHref} className="flex gap-3 text-white/70 hover:text-[#C1272D] transition-colors mb-6">
            <Phone size={18} className="shrink-0 text-[#C1272D]" />
            <span className="text-sm font-light tracking-wide">{riverStone.phone}</span>
          </a>
          <div className="border-t border-white/10 pt-5 space-y-1.5">
            {riverStone.hours.map((h) => (
              <div key={h.day} className="flex justify-between text-xs text-white/50 font-light">
                <span>{h.day}</span><span>{h.time}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-[11px] tracking-[0.15em] text-white/40 uppercase">
          © {new Date().getFullYear()} River Stone Chophouse · Pack Brothers Hospitality
        </p>
        <p className="text-[11px] tracking-[0.15em] text-white/30 uppercase">Concept redesign · Presentation mockup</p>
      </div>
    </div>
  </footer>
);
